import { Grid } from '@statsbomb/kitbag-components';
import React from 'react';
import useClearPlaylist from '../../hooks/clearPlaylistOnLoad';
import LibaryEntryActionMessages from '../LibaryEntryActionMessages';
import StatsbombDataMatchInfo from '../StatsbombDataMatchInfo';
import VideoSearch from '../VideoSearch';
import VideosDisplay from '../VideosDisplay';

export function DownloadFromLibrary() {
  useClearPlaylist();

  return (
    <Grid>
      <Grid item xs={12}>
        <VideoSearch />
        <LibaryEntryActionMessages />
      </Grid>
      <Grid item xs={12}>
        <VideosDisplay />
      </Grid>
      <Grid item xs={12}>
        <StatsbombDataMatchInfo />
      </Grid>
    </Grid>
  );
}

export default { DownloadFromLibrary };
